import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

// Verrou de défilement global (compteur) : le fond ne défile pas tant qu'une fenêtre est ouverte,
// même quand plusieurs fenêtres sont empilées (ex. confirmation par-dessus une fenêtre).
let _lockCount = 0;

export default function Modal({ open, onClose, title, children, footer, testId, wide, xwide, zClass = "z-50" }) {
  useEffect(() => {
    if (!open) return;
    const h = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", h);
    _lockCount += 1;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", h);
      _lockCount = Math.max(0, _lockCount - 1);
      if (_lockCount === 0) document.body.style.overflow = "";
    };
  }, [open, onClose]);
  if (!open) return null;
  return createPortal((
    <div className={`fixed inset-0 ${zClass} flex items-end sm:items-center justify-center p-0 sm:p-4`}
      data-testid={testId || "modal"}>
      <div className="absolute inset-0 bg-[#0B182B]/55 backdrop-blur-[6px] animate-overlay-in" onClick={onClose} />
      <div className={`relative bg-white rounded-t-2xl sm:rounded-2xl w-full ${xwide ? "sm:max-w-5xl" : wide ? "sm:max-w-3xl" : "sm:max-w-lg"} max-h-[92dvh] flex flex-col animate-pop-in`} style={{ boxShadow: "var(--shadow-lg)" }}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-[#E2E8F0] shrink-0">
          <h3 className="text-lg font-semibold text-[#16324F] font-head">{title}</h3>
          <button onClick={onClose} data-testid="modal-close-btn" className="btn-ghost !p-1.5 rounded-lg">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="px-5 py-4 overflow-y-auto flex-1 min-h-0">{children}</div>
        {footer && <div className="px-5 py-4 border-t border-[#E2E8F0] flex justify-end gap-2 bg-[#F8FAFC] rounded-b-2xl shrink-0">{footer}</div>}
      </div>
    </div>
  ), document.body);
}
